import * as React from 'react';
import { Outlet, useMatch } from 'react-router-dom';

import snowGifSrc from '../../assets/img/snow.gif';
import AgentAssistIntegration from '../../components/AgentAssistIntegration';
import Confetti from '../../components/core/Confetti';
import DelayRendering from '../../components/core/DelayRendering';
import FollowUpReminders from '../../components/FollowUpReminders';
import HappyBirthday from '../../components/HappyBirthday';
import TaskReminders from '../../components/TaskReminders/TaskReminders';
import TwilioIntegration from '../../components/TwilioIntegration';
import UserGuiding from '../../components/UserGuiding';
import appConfiguration from '../../constants/appConfiguration';
import featureFlags from '../../constants/featureFlags';
import { useActionCableConsumer } from '../../hooks';
import { ActionCableContext } from '../../utils/actioncable';

const SnowGif = () => {
  const [showImage, setShowImage] = React.useState(false);
  const [showConfetti, setShowConfetti] = React.useState(false);

  const [position, setPosition] = React.useState({ top: 0, left: 0 });
  const clicks = React.useRef(0);

  const handleImageClick = () => {
    setShowConfetti(true);
    setTimeout(() => {
      setShowImage(false);
    }, 10_000);
  };

  React.useEffect(() => {
    const countClicks = () => {
      clicks.current += 1;
      if (clicks.current > 100) {
        const imageWidth = 106;
        const imageHeight = 96;
        const margin = 60;

        const top = Math.random() * (window.innerHeight - imageHeight - margin * 2) + margin;
        const left = Math.random() * (window.innerWidth - imageWidth - margin * 2) + margin;

        setPosition({ top, left });
        setShowImage(true);
        document.removeEventListener('click', countClicks);
      }
    };

    document.addEventListener('click', countClicks);

    return () => {
      document.removeEventListener('click', countClicks);
    };
  }, []);

  if (!showImage) return null;

  return (
    <>
      {showConfetti && <Confetti fireOnMount times={10} />}
      <img
        src={snowGifSrc}
        alt=""
        onClick={handleImageClick}
        style={{
          position: 'absolute',
          width: '106px',
          height: '96px',
          zIndex: 9999999999,
          top: `${position.top}px`,
          left: `${position.left}px`
        }}
      />
    </>
  );
};

const ExtrasLayoutRoute = () => {
  const cableConsumer = useActionCableConsumer();

  const isEmbeddedChromeExtension = !!useMatch('/current_customer_info');
  const hideCallIndicator = featureFlags.hideCallIndicator || isEmbeddedChromeExtension;

  return (
    <ActionCableContext.Provider value={cableConsumer}>
      <DelayRendering>
        <FollowUpReminders />
        <TaskReminders />
        <UserGuiding environment={appConfiguration.environment as 'staging' | 'production'} />
        <HappyBirthday />
      </DelayRendering>
      {hideCallIndicator || <TwilioIntegration />}
      <AgentAssistIntegration />
      {featureFlags.experimentalStuff && <SnowGif />}
      <Outlet />
    </ActionCableContext.Provider>
  );
};

export default ExtrasLayoutRoute;
